// extracted by mini-css-extract-plugin
module.exports = {"condition":"condition___2iX_r"};